export enum ProjectOAuth2ZohoPrompt {
    Consent = 'consent',
}
